exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".segment-tab[data-v-ce180958]{display:-webkit-box;display:-ms-flexbox;display:flex}.segment-tab .tab-default[data-v-ce180958]{height:34px;line-height:34px;text-align:center;font-size:16px;color:#333;border-radius:4px;margin-right:20px;padding:0 10px;cursor:pointer}.segment-tab .tab-default[data-v-ce180958]:last-child{margin-right:0}.segment-tab .tab-default[data-v-ce180958]:active{opacity:.8}.segment-tab .active[data-v-ce180958]{color:#fff;background:#0095ff}", ""]);

// exports
